// Notification bell strings (auto-merged by lib/i18n.ts).
export const en = {
  'ds.notificationbell.label': 'Notifications',
}

export const zhTW = {
  'ds.notificationbell.label': '通知',
}
